import StudentIdColumn from './StudentIdColumn';

export default StudentIdColumn;
